import React from 'react';
// import data
import { nav } from '../data';
import { Link } from 'react-router-dom'

const Nav = () => {
  return (
    <nav>
      <ul className='flex gap-x-10'>
        {nav.map((item, index) => {
          // destructure item
          const { href, name } = item;
          return (
            <li key={index}>
              <Link to={href}
                className='hover:text-sky-300 transition hover:underline'>
                {name}
              </Link>
              {/* <a className='hover:text-rose-400 transition hover:underline' href={href}>
                {name}
              </a> */}
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default Nav;
